import { render, staticRenderFns } from "./UploadQuestions.vue?vue&type=template&id=bfdfc698&"
import script from "./UploadQuestions.vue?vue&type=script&lang=js&"
export * from "./UploadQuestions.vue?vue&type=script&lang=js&"
import style0 from "./UploadQuestions.vue?vue&type=style&index=0&id=bfdfc698&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports